import React, { useState, useEffect } from "react";
import Header from '../include/header';
import Footer from '../include/footer';
import LeftPanel from '../include/LeftPanel';
import Global from "../../APIConfig";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import MainLoader from "../Loaders/MainLoader";
import ListLoader from "../Loaders/ListLoader";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from '../../components/ui/toast';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {
    ArrowLeft, Plus, Printer, Download, Filter, Search, Copy, Trash2,
    Barcode, FileText, Receipt, CalendarRange, X, PackageOpen
} from "lucide-react";

/**
 * ShipmentListContent — shipment list (status pills, search, toolbar, filter drawer).
 * Used both by the standalone /Shipmentlist/:type page and the /Shipping hub tabs.
 * @param {string} type  initial status scope: All | B | T | IT | D | C | R
 */
export function ShipmentListContent({ type }) {
    let navigate = useNavigate();
    const [list, setList] = useState([]);
    const [searchtype, setSearchtype] = useState('Any');
    const [searchvalue, setSearchvalue] = useState('');
    const [showpage, setShowpage] = useState(type);
    const [searchstatus, setSearchstatus] = useState('');
    const [searchorigin, setSearchorigin] = useState('');
    const [searchdestination, setSearchdestination] = useState('');
    const [searchship, setSearchship] = useState('');
    const [searchstartdate, setSearchstartdate] = useState('');
    const [searchenddate, setSearchenddate] = useState('');
    const [searchcarrier, setSearchcarrier] = useState('');
    const [originList, setOriginList] = useState([]);
    const [destinationList, setDestinationList] = useState([]);
    const [originarray, setOriginarray] = useState('');
    const [destinationarray, setDestinationarray] = useState('');
    const [Loading, setLoading] = useState(true);
    const [SubLoading, setSubLoading] = useState(false);
    const { headers1, headers2, logout } = AuthUser();
    const [checkedItems, setCheckedItems] = useState([]);
    const [filterOpen, setFilterOpen] = useState(false);

    useEffect(() => {
        GetShipmentList(type, '');
    }, []);

    useEffect(() => {
        if (!filterOpen) return;
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const onKey = (e) => { if (e.key === 'Escape') setFilterOpen(false); };
        window.addEventListener('keydown', onKey);
        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKey);
        };
    }, [filterOpen]);

    const items = JSON.parse(localStorage.getItem('user'));

    const GetShipmentList = (type, val) => {
        setSubLoading(true);
        setShowpage(type);
        setSearchvalue(val)
        axios({
            method: 'post',
            url: Global.baseUrl + 'customershowshipmentlist',
            headers: headers1,
            data: {
                pagetype: type,
                usertype: items.usertype,
                custid: items.uniqueid,
                searchtype: searchtype,
                searchvalue: val,
                searchstatus: searchstatus,
                searchorigin: originarray,
                searchdestination: destinationarray,
                searchship: searchship,
                searchstartdate: searchstartdate,
                searchenddate: searchenddate,
                searchcarrier: searchcarrier,
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value.data;
                    setList(data);
                    setLoading(false);
                    setSubLoading(false);
                }
                else {
                    setList();
                    setLoading(false);
                    setSubLoading(false);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
            });
    }

    const handelclearbutton = () => {
        setSearchstatus('');
        setSearchship('');
        setSearchcarrier('');
        setOriginList([]);
        setDestinationList([]);
        setOriginarray('');
        setDestinationarray('');
        setSearchorigin('');
        setSearchdestination('');
        setSearchstartdate('');
        setSearchenddate('');
        GetShipmentList('', '');
    }

    const handleshpmentstatus = (e) => {
        const status = e.target.value;
        if (!searchstatus.includes(status)) {
            setSearchstatus([...searchstatus, status]);
        } else {
            let arr = searchstatus.filter((item) => item !== status);
            setSearchstatus(arr);
        }
    }

    const handleshpmentdata = (e) => {
        const status = e.target.value;
        if (!searchship.includes(status)) {
            setSearchship([...searchship, status]);
        } else {
            let arr = searchship.filter((item) => item !== status);
            setSearchship(arr);
        }
    }

    const handleshpmentcarrier = (e) => {
        const status = e.target.value;
        if (!searchcarrier.includes(status)) {
            setSearchcarrier([...searchcarrier, status]);
        } else {
            let arr = searchcarrier.filter((item) => item !== status);
            setSearchcarrier(arr);
        }
    }

    const showOrigincity = (val) => {
        setSearchorigin(val);
        axios({
            method: 'post',
            url: Global.baseUrl + 'GetCitylistbySearchValue',
            data: {
                cityvalue: searchorigin,
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setOriginList(data);
                }
                else {
                    setOriginList();
                }
            })
    }

    const showDestinationcity = (val) => {
        setSearchdestination(val);
        axios({
            method: 'post',
            url: Global.baseUrl + 'GetCitylistbySearchValue',
            data: {
                cityvalue: searchdestination,
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setDestinationList(data);
                }
                else {
                    setDestinationList();
                }
            })
    }

    const handleshpmentorigin = (e) => {
        const status = e.target.value;
        if (!originarray.includes(status)) {
            setOriginarray([...originarray, status]);
        } else {
            let arr = originarray.filter((item) => item !== status);
            setOriginarray(arr);
        }
    }

    const handleshpmentdestination = (e) => {
        const status = e.target.value;
        if (!destinationarray.includes(status)) {
            setDestinationarray([...destinationarray, status]);
        } else {
            let arr = destinationarray.filter((item) => item !== status);
            setDestinationarray(arr);
        }
    }

    const ShipmentDelete = (id) => {
        if (window.confirm('Do You  want to delete ?')) {
            axios({
                method: 'post',
                url: Global.baseUrl + 'CustomerShipmentDelete',
                headers: headers1,
                data: {
                    slip_no: id
                }
            })
                .then(function (response) {
                    if (response.data.status == 200) {
                        toast.success(response.data.message);
                    }
                    else {
                        toast.warn(response.data.message);
                    }
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                });
            GetShipmentList(showpage, '');
        } else {
            GetShipmentList(showpage, '');
        }
    }

    const handleChange = (event) => {
        const slip_no = event.target.value;
        if (!checkedItems.includes(slip_no)) {
            setCheckedItems([...checkedItems, slip_no]);
        } else {
            let arr = checkedItems.filter((item) => item !== slip_no);
            setCheckedItems(arr);
        }
    };

    const handleSelectAllChange = (event) => {
        if (event.target.checked) {
            const allSlipNos = list.map(item => item.slip_no);
            setCheckedItems(allSlipNos);
        } else {
            setCheckedItems([]);
        }
    };

    const isChecked = (slip_no) => checkedItems.includes(slip_no);

    const Printlabel = () => {
        if (checkedItems.length > 0) {
            const explodedData = checkedItems.join("-");
            const url = `/ShipmentLabel?slipno=${explodedData}`;
            window.open(url, '_blank');
        }
        else {
            toast.warn("At Least One Shipment Seleted");
        }
    }
    const importshipment = () => {
        if (checkedItems.length > 0) {
            axios({
                method: 'post',
                url: Global.baseUrl + 'Customerselectedshipmentimport',
                headers: headers1,
                data: {
                    slip_no: checkedItems
                }
            })
                .then(function (response) {
                    if (response.data.status == 200) {
                        toast.success("Excel Download Successfully");
                        // Create a new workbook
                        const wb = XLSX.utils.book_new();
                        // Convert data to a worksheet
                        const ws = XLSX.utils.json_to_sheet(response.data.excelvalue);
                        // Append the worksheet to the workbook
                        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
                        // Generate a buffer for the workbook
                        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                        // Create a Blob object from the buffer
                        const blob = new Blob([wbout], { type: 'application/octet-stream' });
                        // Save the file using file-saver
                        saveAs(blob, 'Shipmentdata.xlsx');
                    }
                    else {
                        toast.warn(response.data.message);
                    }
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                });
        }
        else {
            toast.warn("At Least One Shipment Seleted");
        }
    }

    const tabs = [
        { key: 'All', label: 'All' },
        { key: 'B', label: 'Booked' },
        { key: 'T', label: 'Picked Up' },
        { key: 'IT', label: 'In Transit' },
        { key: 'D', label: 'Delivered' },
        { key: 'C', label: 'Cancel' },
        { key: 'R', label: 'Return' },
    ];

    const filterSection = (title, children) => (
        <div className="px-filter-section">
            <div className="px-filter-section__title">{title}</div>
            <div className="px-filter-section__body">{children}</div>
        </div>
    );

    if (Loading) return <MainLoader />;

    return (
        <>
            <div className="px-pagehead">
                <div className="px-pagehead__left">
                    <button className="px-btn px-btn--ghost px-btn--sm" onClick={() => navigate(-1)} aria-label="Go back">
                        <ArrowLeft size={16} />
                    </button>
                    <h2 className="px-pagehead__title">Shipments</h2>
                </div>
                <div className="px-pagehead__actions">
                    <Link className="px-btn px-btn--primary" to="/Createshipment">
                        <Plus size={16} /> New
                    </Link>
                    <button className="px-btn px-btn--secondary" onClick={() => Printlabel()}>
                        <Printer size={16} /> Print Label
                    </button>
                    <button className="px-btn px-btn--secondary" onClick={() => importshipment()}>
                        <Download size={16} /> Export Data
                    </button>
                    <button className="px-btn px-btn--secondary" onClick={() => setFilterOpen(true)}>
                        <Filter size={16} /> Filter
                    </button>
                </div>
            </div>

            <div className="px-listbar">
                <div className="px-tabs px-tabs--pills">
                    {tabs.map((t) => (
                        <button key={t.key}
                            className={`px-tab${showpage == t.key ? ' px-tab--active' : ''}`}
                            onClick={() => GetShipmentList(t.key, '')}>
                            {t.label}
                        </button>
                    ))}
                </div>
                <select className="px-select px-tabs__select" value={showpage || 'All'} aria-label="Filter by status"
                    onChange={(e) => GetShipmentList(e.target.value, '')}>
                    {tabs.map((t) => (
                        <option key={t.key} value={t.key}>{t.label}</option>
                    ))}
                </select>
                <div className="px-search-group">
                    <select className="px-select px-search-group__type" value={searchtype} onChange={(e) => setSearchtype(e.target.value)}>
                        <option value="Any">Any</option>
                        <option value="AWB">AWB #</option>
                        <option value="Order">Order #</option>
                        <option value="Phone_Number">Phone Number</option>
                    </select>
                    <input type="text" className="px-input" placeholder="Search shipments"
                        value={searchvalue} onChange={(e) => GetShipmentList(showpage, e.target.value)} />
                    <span className="px-search-group__icon"><Search size={16} /></span>
                </div>
            </div>

            <div className="px-table-wrap">
                <table className="px-table">
                    <thead>
                        <tr>
                            <th className="px-col-check">
                                {list != undefined ?
                                    <input type="checkbox" className="px-checkbox" onChange={handleSelectAllChange} checked={checkedItems.length === list.length} />
                                    : ''
                                }
                            </th>
                            <th>AWB#</th>
                            <th>Booking Type</th>
                            <th>Origin</th>
                            <th>Destination</th>
                            <th>Sender</th>
                            <th>Receiver</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    {SubLoading == true ? <tbody><tr><td colSpan={9}><ListLoader /></td></tr></tbody> :
                        <tbody>
                            {list != undefined ?
                                <>
                                    {list.map((ship, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <input type="checkbox" className="px-checkbox" id={index} value={ship.slip_no} checked={isChecked(ship.slip_no)} onChange={handleChange} />
                                                </td>
                                                <td>
                                                    <div className="px-awb">
                                                        <Link to={`/ShipmentDetails/${ship.slip_no}`} className="px-awb__no">{ship.slip_no}</Link>
                                                        <CopyToClipboard text={ship.slip_no} onCopy={() => { toast.success(ship.slip_no + ' Copied To Clipboard'); }}>
                                                            <button className="px-awb__copy" aria-label="Copy AWB"><Copy size={13} /></button>
                                                        </CopyToClipboard>
                                                    </div>
                                                    <small className="px-awb__date">{ship.entrydate}</small>
                                                </td>
                                                <td className="text-capitalize">{ship.shipment_type}</td>
                                                <td className="text-capitalize">{ship.sendercity}, {ship.sendercountry}</td>
                                                <td className="text-capitalize">{ship.receivercity}, {ship.receivercountry}</td>
                                                <td>
                                                    <div className="fw-normal text-capitalize">{ship.sender_name}</div>
                                                    <small className="px-muted-sm">{ship.sender_company_name}</small>
                                                </td>
                                                <td>
                                                    <div className="fw-normal text-capitalize">{ship.reciever_name}</div>
                                                    <small className="px-muted-sm">{ship.receiver_company_name}</small>
                                                </td>
                                                <td>
                                                    <div className="px-cell-badges">
                                                        <span className="px-badge px-badge--neutral">{ship.nrd}</span>
                                                        {ship.booking_mode == 'Prepaid' ?
                                                            <span className="px-badge px-badge--success">Prepaid</span>
                                                            :
                                                            <span className="px-badge px-badge--warning">COD</span>
                                                        }
                                                    </div>
                                                </td>
                                                <td><span dangerouslySetInnerHTML={{ __html: ship.shipmentstatus }}></span></td>
                                                <td>
                                                    <div className="px-row-actions">
                                                        <Link to={`/ShipmentLabel?slipno=${ship.slip_no}`} target="_blank" className="px-icon-btn" title="Download Label"><Barcode size={15} /></Link>
                                                        <Link to={`/ShipmentPrintReceipt/${ship.slip_no}`} target="_blank" className="px-icon-btn" title="Print Receipt"><Receipt size={15} /></Link>
                                                        <Link to={`/ShipmentInvoice/${ship.slip_no}`} target="_blank" className="px-icon-btn" title="Print Invoice"><FileText size={15} /></Link>
                                                        <Link to={`/ConsignmentNote/${ship.slip_no}`} target="_blank" className="px-icon-btn" title="Consignment Note"><CalendarRange size={15} /></Link>
                                                        <button className="px-icon-btn px-icon-btn--danger" title="Delete" onClick={() => ShipmentDelete(ship.slip_no)}><Trash2 size={15} /></button>
                                                        {ship.shipment_type == 'International' &&
                                                            <a href="#" className="px-icon-btn" title="Forward through"><PackageOpen size={15} /></a>
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </>
                                :
                                <tr>
                                    <td colSpan="9" className="px-table__empty">Record Not Found</td>
                                </tr>
                            }
                        </tbody>
                    }
                </table>
            </div>

            <div className="px-listfoot">
                <nav aria-label="Page navigation example">
                    <ul className="pagination pagination-sm mb-0">
                        <li className="page-item"><a className="page-link" href="#">Previous</a></li>
                        <li className="page-item"><a className="page-link" href="#">1</a></li>
                        <li className="page-item active"><a className="page-link" href="#">2</a></li>
                        <li className="page-item"><a className="page-link" href="#">3</a></li>
                        <li className="page-item"><a className="page-link" href="#">4</a></li>
                        <li className="page-item"><a className="page-link" href="#">5</a></li>
                        <li className="page-item"><a className="page-link" href="#">Next</a></li>
                    </ul>
                </nav>
                <div className="px-muted-sm">Showing <b>5</b> out of <b>25</b> entries</div>
            </div>

            {filterOpen && (
                <>
                    <div className="px-drawer-backdrop" onClick={() => setFilterOpen(false)}></div>
                    <div className="px-drawer px-drawer--open">
                        <div className="px-drawer__head">
                            <span className="px-card__title">Shipment Filter</span>
                            <button className="px-icon-btn" onClick={() => setFilterOpen(false)} aria-label="Close filter"><X size={17} /></button>
                        </div>
                        <div className="px-drawer__body">
                            {filterSection('Shipment Status', (
                                <div className="px-filter-checks">
                                    {[
                                        ['All', 'All'], ['B', 'Booked'], ['T', 'Picked Up'],
                                        ['IT', 'In Transit'], ['C', 'Canceled'], ['D', 'Delivered'],
                                    ].map(([v, l]) => (
                                        <label className="px-check" key={v}>
                                            <input type="checkbox" checked={searchstatus.includes(v) || false} value={v} onChange={handleshpmentstatus} />
                                            {l}
                                        </label>
                                    ))}
                                </div>
                            ))}

                            {filterSection('Location', (
                                <>
                                    <div className="px-form-group">
                                        <label>Origin</label>
                                        <input type="text" className="px-input" value={searchorigin} placeholder="Search Location"
                                            aria-label="Search origin" onChange={(e) => showOrigincity(e.target.value)} />
                                        <div className="px-filter-checks">
                                            {originList != undefined ?
                                                <>
                                                    {originList.map((lab, i) => {
                                                        return (
                                                            <label className="px-check" key={i}>
                                                                <input type="checkbox" checked={originarray.includes(lab.id)} value={lab.id} onChange={(e) => handleshpmentorigin(e)} />
                                                                {lab.city}
                                                            </label>
                                                        );
                                                    })}
                                                </>
                                                : ''
                                            }
                                        </div>
                                    </div>
                                    <div className="px-form-group">
                                        <label>Destination</label>
                                        <input type="text" className="px-input" value={searchdestination} placeholder="Search Location"
                                            aria-label="Search destination" onChange={(e) => showDestinationcity(e.target.value)} />
                                        <div className="px-filter-checks">
                                            {destinationList != undefined ?
                                                <>
                                                    {destinationList.map((city, inde) => {
                                                        return (
                                                            <label className="px-check" key={inde}>
                                                                <input type="checkbox" checked={destinationarray.includes(city.id) || false} value={city.id} onChange={(e) => handleshpmentdestination(e)} />
                                                                {city.city}
                                                            </label>
                                                        );
                                                    })}
                                                </>
                                                : ''
                                            }
                                        </div>
                                    </div>
                                </>
                            ))}

                            {filterSection('Shipment Data', (
                                <>
                                    <div className="px-form-group">
                                        <label>Shipment</label>
                                        <div className="px-filter-checks">
                                            <label className="px-check"><input type="checkbox" checked={searchship.includes('Domestic') || false} value="Domestic" onChange={handleshpmentdata} />Domestic</label>
                                            <label className="px-check"><input type="checkbox" checked={searchship.includes('International') || false} value="International" onChange={handleshpmentdata} />International</label>
                                        </div>
                                    </div>
                                    <div className="px-form-group">
                                        <label>Shipment Type</label>
                                        <div className="px-filter-checks">
                                            <label className="px-check"><input type="checkbox" checked={searchship.includes('Parcel') || false} value="Parcel" onChange={handleshpmentdata} />Parcel</label>
                                            <label className="px-check"><input type="checkbox" checked={searchship.includes('Document') || false} value="Document" onChange={handleshpmentdata} />Document</label>
                                        </div>
                                    </div>
                                    <div className="px-form-group">
                                        <label>Shipment Payment</label>
                                        <div className="px-filter-checks">
                                            <label className="px-check"><input type="checkbox" checked={searchship.includes('Prepaid') || false} value="Prepaid" onChange={handleshpmentdata} />Prepaid</label>
                                            <label className="px-check"><input type="checkbox" checked={searchship.includes('COD') || false} value="COD" onChange={handleshpmentdata} />COD (Cash on delivery)</label>
                                        </div>
                                    </div>
                                </>
                            ))}

                            {filterSection('Date Range', (
                                <>
                                    <div className="px-form-group">
                                        <label>From Date</label>
                                        <input type="date" className="px-input" value={searchstartdate} onChange={(e) => setSearchstartdate(e.target.value)} />
                                    </div>
                                    <div className="px-form-group">
                                        <label>To Date</label>
                                        <input type="date" className="px-input" value={searchenddate} onChange={(e) => setSearchenddate(e.target.value)} />
                                    </div>
                                </>
                            ))}

                            {filterSection('Carriers', (
                                <div className="px-filter-checks">
                                    {[['Any', 'Any'], ['DHL', 'DHL'], ['Fedex', 'Fedex']].map(([v, l]) => (
                                        <label className="px-check" key={v}>
                                            <input type="checkbox" checked={searchcarrier.includes(v) || false} value={v} onChange={handleshpmentcarrier} />
                                            {l}
                                        </label>
                                    ))}
                                </div>
                            ))}
                        </div>
                        <div className="px-drawer__foot">
                            <button className="px-btn px-btn--secondary" onClick={() => handelclearbutton()}>Clear</button>
                            <button className="px-btn px-btn--primary" onClick={() => { GetShipmentList(showpage, ''); setFilterOpen(false); }}>Apply</button>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

function Shipmentlist() {
    let { type } = useParams();
    return (
        <>
            <LeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                <div className="px-content">
                    <ShipmentListContent type={type} />
                </div>
                <Footer />
            </main>
        </>
    );
}
export default Shipmentlist;
